import { FunctionComponent, useEffect, useState } from 'react';

interface NewProps {
  news: any,
  key?: any,
  onClickNewsItem: Function,
}

const NewItem: FunctionComponent<NewProps> = (props: any) => {

  const [news, setNews] = useState({} as any);

  useEffect(() => {
    setNews(props.news);
  }, [props.news])

  const onclickItem = (news: any) => {
    props.onClickNewsItem(news);
  }

  const modalNews = (type: any) => {
    let modalN = <li></li>
    if (type == 'new') {
      modalN = <li
        className="li-widget"
        style={{
          display: 'flex',
          flexDirection: 'row',
          border: '1px solid #E7E7E7',
          borderRadius: '10px',
          cursor: 'pointer'
        }}
        onClick={onclickItem.bind(this, news)}
      >
        <div style={{
          textAlign: 'left',
          width: '25%',
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <span
            style={{
              fontWeight: 'bold',
              paddingLeft: 10,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              fontSize: '14px'
            }}>
            {props.news['Subject']}
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '75%',
            margin: 'auto'
          }}
        >
          <span
            id='contenedor'
            style={{
              height: '100%',
              paddingLeft: 2,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              fontSize: '14px'
            }}
          >
          </span>
        </div>
      </li>
    } else if (type == 'new-ccy') {
      modalN = <li
        className="li-widget"
        style={{
          display: 'flex',
          flexDirection: 'row',
          border: '1px solid #E7E7E7',
          borderRadius: '10px',
          cursor: 'pointer'
        }}
        onClick={onclickItem.bind(this, news)}
      >
        <div style={{
          textAlign: 'left',
          width: '25%',
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <span
            style={{
              fontWeight: 'bold',
              paddingLeft: 10,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              fontSize: '14px'
            }}>
            {props.news['Subject']}
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '75%',
            margin: 'auto'
          }}
        >
          <span
            style={{
              height: '100%',
              paddingLeft: 2,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              fontSize: '14px'
            }}
          >
            {props.news["Message"]}</span>
        </div>
      </li>
    }
    return modalN;
  }

  return (
    modalNews(props.news['Type'])
  );
}
export default NewItem;